module.exports = __webpack_public_path__ + "static/media/suoping.f313d61.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/suoping.mp4
// module id = eCQ0
// module chunks = 1